import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import logo from "./Images/regantesolponienteportada.jpeg";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();


  useEffect(() => {
    // if (localStorage.getItem("accessToken")) {
    //     navigate("/home");
    // }
  }, []);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      // Hacer la solicitud POST al endpoint de login
      const response = await fetch("https://oficinavirtual-solponiente.com/api/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username: email, password: password }),
      });

      const data = await response.json();

      if (response.ok) {
        // Guardar el token en localStorage
        localStorage.setItem("token", data.token);
        localStorage.setItem ("rol", data.rol);
        localStorage.setItem ("id", data.id);
        navigate("/home")
        alert("Inicio de sesión exitoso.");
      } else {
        setError(data.message || "Error en el inicio de sesión");
      }
    } catch (err) {
      setError("Ocurrió un error al conectarse con el servidor");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container
      fluid
      className="d-flex align-items-center justify-content-center vh-100 bg-light"
    >
      <Row>
        <Col>
          <Card
            className="shadow-sm"
            style={{ maxWidth: "400px", margin: "auto" }}
          >
            <Card.Body>
              <div className="text-center mb-4">
                {/* <h4 className="fw-bold text-primary">Oficina Virtual</h4>{" "}
                <b>Solponiente</b> */}
                <img
                  src={logo} // Reemplaza con tu logo
                  alt="Logo"
                  className="img-fluid mb-1 mt-3"
                  style={{ maxWidth: "100%" }}
                />
              </div>
              <Form onSubmit={handleSubmit}>
                <Form.Group controlId="formEmail" className="mb-3">
                  <Form.Label>Usuario</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Ingresa tu correo electrónico"
                    value={email} // Enlaza el estado email
                    onChange={(e) => setEmail(e.target.value)} // Actualiza el estado email
                    required
                  />
                </Form.Group>

                <Form.Group controlId="formPassword" className="mb-4">
                  <Form.Label>Contraseña</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Ingresa tu contraseña"
                    value={password} // Enlaza el estado password
                    onChange={(e) => setPassword(e.target.value)} // Actualiza el estado password
                    required
                  />
                </Form.Group>

                <Button variant="primary" type="submit" className="w-100">
                  Acceder
                </Button>
              </Form>
              <div className="text-center mt-3">
                <small className="text-muted">
                  ¿Problemas para acceder? Contacte con el administrador.
                </small>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
